<script setup>
import { ref } from 'vue'
import Confetti from 'vue-confetti/src/confetti'

const confetti = new Confetti({})

const playerSolution = ref("")
const number = ref(0) // same number twice: number + number
const solutionInput = ref(null)
const sumClass = ref("")

const inProgress = ref(false)
const gameSetup = ref(false)
const max = ref(20)
const lastNumber = ref(null)

const currentScore = ref(0)
const winningScore = 10

const playSound = (filename) => {
  const audio = new Audio(`/${filename}`)
  audio.play().catch(() => {})
}

// Pick a random number from 1..max, not repeating the last one
const setupDoubles = () => {
  const choices = []
  for (let i = 1; i <= max.value; i++) {
    if (i !== lastNumber.value) choices.push(i)
  }
  const n = choices.length
    ? choices[Math.floor(Math.random() * choices.length)]
    : 1
  lastNumber.value = n
  number.value = n
}

const resetGame = () => {
  inProgress.value = true
  lastNumber.value = null
  setupDoubles()
}

const setupGame = () => {
  gameSetup.value = true
  resetGame()
}

const submitSolution = () => {
  sumClass.value = ""
  const correct = number.value + number.value
  if (playerSolution.value == correct) {
    playSound("correct.mp3")
    currentScore.value++
    playerSolution.value = ""
    setupDoubles()
    solutionInput.value?.focus()
  } else {
    playSound("incorrect.mp3")
    sumClass.value = "incorrect"
  }
  if (currentScore.value === winningScore) {
    inProgress.value = false
    playSound("fanfare.mp3")
    confetti.start()
    window.setTimeout(() => {
      confetti.stop()
      currentScore.value = 0
      resetGame()
      inProgress.value = true
    }, 7000)
  }
}
</script>

<template>
  <div class="game doubles">
    <div v-if="gameSetup">
      <div v-if="inProgress">
        <p>
          Add the same number to itself (doubles):
        </p>
        <div class="sum">
          {{ number }} + {{ number }} =
          <input
            class="solution"
            :class="sumClass"
            ref="solutionInput"
            v-model="playerSolution"
            @keyup.enter.prevent="submitSolution"
          />
        </div>
        <div>
          <div class="button yes disable-touch-action" @click="submitSolution">
            Submit
          </div>
          <div>
            <progress id="file" :value="currentScore" :max="winningScore"></progress>
          </div>
        </div>
      </div>
      <div v-else class="winner">
        <p>Winner!</p>
      </div>
    </div>
    <div class="setup" v-else>
      <p>Choose the maximum number for doubles (e.g. max 20 gives 1+1 up to 20+20)</p>
      <div class="field">
        <label>Maximum</label>
        <input
          class="input"
          type="number"
          v-model="max"
          @focus="$event.target.select()"
        />
      </div>
      <div>
        <div class="button is-primary" @click="setupGame">Go</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.game {
  .sum {
    font-size: 30px;
    margin: 30px;
  }

  input.solution {
    font-size: 30px;
    width: 80px;
    text-align: center;
    border: 1px solid rgba(200, 200, 200, 1);

    &:focus-visible,
    &:focus {
      outline: none;
    }

    &.incorrect {
      animation: pulse 1s 1;
    }
  }

  .button {
    border: 1px solid #ccc;
    display: inline-block;
    min-width: 100px;
    cursor: pointer;

    &.yes {
      background-color: #12762b;
      color: white;
    }

    &.disable-touch-action {
      touch-action: manipulation;
    }
  }

  progress {
    margin: 20px;
  }

  @keyframes pulse {
    0% {
      border-color: rgba(200, 200, 200, 1);
    }
    70% {
      border-color: rgba(200, 30, 30, 1);
    }
    100% {
      border-color: rgba(200, 200, 200, 1);
    }
  }
}
</style>
